import { cn } from '../../lib/utils'

export default function Button({
  children,
  variant = 'primary',
  size = 'default',
  className,
  ...props
}) {
  const baseStyles = 'font-semibold rounded-none transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-dark-900 transform hover:-translate-y-0.5 hover:shadow-lg'

  const variants = {
    primary: 'border-2 border-neon-lime text-neon-lime hover:border-neon-yellow hover:text-neon-yellow hover:shadow-neon-lime/40 focus:ring-neon-lime',
    secondary: 'border-2 border-neon-pink text-neon-pink hover:border-neon-purple hover:text-neon-purple focus:ring-neon-pink hover:shadow-neon-pink/40',
    outline: 'border-2 border-neon-orange text-neon-orange hover:border-neon-yellow hover:text-neon-yellow focus:ring-neon-orange hover:shadow-neon-orange/20'
  }

  const sizes = {
    small: 'px-5 py-2.5 text-sm',
    default: 'px-8 py-3.5 text-base',
    large: 'px-10 py-4 text-lg'
  }

  return (
    <button
      className={cn(baseStyles, variants[variant], sizes[size], className)}
      {...props}
    >
      {children}
    </button>
  )
}
